export default {
    props: {
        defaultCloseHandler: {
            type: Function,
            default: () => { }
        }
    }
};
